"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const Core_1 = require("./Core");
const NamedFunctions_1 = require("./NamedFunctions");
const RegularFunctions_1 = require("./RegularFunctions");
const SpecialFunctions_1 = require("./SpecialFunctions");
__export(require("./Core"));
exports.regularFunctions = RegularFunctions_1.definitions
    .map((def, op) => new Core_1.RegularFunction(op, def))
    .toMap();
exports.specialFunctions = SpecialFunctions_1.specialDefinitions
    .map((def, op) => new Core_1.SpecialFunction(op, def))
    .toMap();
exports.namedFunctions = NamedFunctions_1.namedDefinitions
    .map((def, op) => new Core_1.NamedFunction(op, def))
    .toMap();
//# sourceMappingURL=index.js.map